import { trans, viewsMap } from './';

export const getViewName = name => {
  switch (true) {
    case name.includes(viewsMap.FRONT):
      return trans('Przód');
    case name.includes(viewsMap.INSIDE):
      return trans('Wnętrze');
    case name.includes(viewsMap.BACK):
      return trans('Tył');
    default:
      return trans('Pozostałe');
  }
};
